<template>
  <div class="data_add">
    <el-form
      :model="data.elForm"
      :rules="data.rules"
      ref="addAlterForm"
      class="el_from"
    >
      <el-form-item label="记录名称" prop="recordName">
        <el-input
          v-model="data.elForm.recordName"
          maxlength="20"
          placeholder="请输入内容"
        ></el-input>
        <span class="remark_span">不超过20个字符</span>
      </el-form-item>
      <el-form-item label="数据key" prop="ptDataKey">
        <el-input
          v-model="data.elForm.ptDataKey"
          maxlength="20"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="数据值" prop="val">
        <el-input
          v-model="data.elForm.val"
          maxlength="20"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="数据时间" prop="dataTime">
        <el-date-picker
          value-format="timestamp"
          placement="bottom-start"
          v-model="data.elForm.dataTime"
          type="datetime"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="排序号" prop="sortNumber">
        <el-input
          v-model="data.elForm.sortNumber"
          maxlength="20"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="生效标记" prop="enableSign">
        <el-select
          v-model="data.elForm.enableSign"
          placeholder="请选择内容"
          clearable
        >
          <el-option
            v-for="item in enableSignList"
            :key="item.infoCode"
            :label="item.infoName"
            :value="item.infoCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述/备注" prop="remark">
        <el-input
          type="textarea"
          v-model="data.elForm.remark"
          maxlength="100"
          placeholder="请输入内容"
        ></el-input>
        <span class="remark_span">不超过100个字符</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog_footer">
      <button class="button_style0" @click="cancelClick">
        <i class="iconfont icon-quxiao1"></i>取消
      </button>
      <button class="button_style0" @click="submitClick('addAlterForm')">
        <i class="iconfont icon-tijiao"></i>保存
      </button>
      <button class="button_style0" @click="resetClick">
        <i class="iconfont icon-zhongzhi3"></i>重置
      </button>
    </div>
  </div>
</template>
  
  <script>
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import fun from "@/util/util";
export default {
  props: {
    dataId: {
      type: [String, Number],
      default: "",
    },
    nodeId: {
      type: [String, Number],
      default: "",
    },
    enableSignList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data: {
        elForm: {
          recordName: "", //记录名称
          ptDataKey: "", //数据key
          val: "", //数据值
          dataTime: "", //数据时间
          enableSign: "0", //生效标记
          sortNumber: "", //排序号
          remark: "", //描述/备注
        },
        rules: {
          recordName: [
            { required: true, message: "请选择信息", trigger: "change" },
          ],
          val: [{ required: true, message: "请选择信息", trigger: "change" }],
        },
      },
      comparisonData: {},
    };
  },
  watch: {
    nodeId(val) {
      if (val) {
        this.getOneInfo();
      }
    },
  },
  methods: {
    //根据节点id查询单条节点信息
    getOneInfo() {
      if (this.nodeId != 0) {
        this.$axios
          .get(myApi.getOneSimulatePointInfo + "?id=" + this.nodeId)
          .then((res) => {
            if (res.data.code === myConst.code.success) {
              this.data.elForm = res.data.data;
              this.data.elForm.enableSign = this.data.elForm.enableSign + "";
              this.data.elForm.dataId = this.dataId;
              this.comparisonData = JSON.parse(
                JSON.stringify(this.data.elForm)
              );
            } else {
              this.data.elForm = {};
            }
          });
      }
    },

    //取消按钮
    cancelClick() {
      this.$emit("closeControlpopover"); //关闭弹窗
    },

    //保存按钮
    submitClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let initData = JSON.stringify(this.comparisonData);
          let changeData = JSON.stringify(this.data.elForm);
          if (initData == changeData) {
            this.$message({ message: "未发生改变", type: "info" });
          } else {
            this.$confirm("确认要添加吗？", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
            })
              .then(() => {
                this.$axios
                  .post(myApi.alterSimulatePoint, this.data.elForm)
                  .then((res) => {
                    if (res.data.code === myConst.code.success) {
                      this.$emit("loadDataList");
                      this.$emit("upData");
                      this.$message({
                        message: res.data.data,
                        type: "success",
                      });
                    }
                  })
                  .catch(() => {});
              })
              .catch(() => {});
          }
        }
      });
    },

    //重置按钮
    resetClick() {
        this.getOneInfo();
    },
  },
};
</script>
  
  <style scoped>
.data_add {
  width: 100%;
  height: 100%;
}

.el_from {
  width: 100%;
  height: 92%;
  /* background-color: #fff; */
  overflow: auto;
  position: absolute;
}

::v-deep .el-select,
.el-input,
.el-textarea {
  width: 30rem;
}

::v-deep .el-form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15rem;
  box-sizing: border-box;
}

::v-deep .el-form-item__label {
  width: 15rem;
}

.formula {
  color: #fde223;
  font-size: 1.8rem;
}

.dialog_footer {
  position: absolute;
  bottom: 0rem;
  width: 100%;
  display: flex;
  justify-content: center;
}

::v-deep .dialog_table {
  margin-left: 15rem;
  color: #00dafc;
}
</style>